import { Typography } from "@/components/ui/typography";
import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export const CampaignNotFound = () => {
  const { t } = useTranslation();
  return (
    <motion.div className="flex h-full flex-col items-center justify-center gap-4 p-4">
      <Typography tag="h1">{t("general.notFound")}</Typography>
    </motion.div>
  );
};
